/* unplugin-vue-components disabled */import script from "./TopPersonalBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopPersonalBtn.vue?vue&type=script&setup=true&lang=ts"

import "./TopPersonalBtn.vue?vue&type=style&index=0&id=49851b27&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49851b27"]])

export default __exports__